//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Langs from "../Lang/index.vue";
export default {
  components: { Langs },
  inject: ["parentCom"],
  data() {
    return {
      clickTimes: 0,
      telegram_credential: window.telegram_credential,
    };
  },
  computed: {
    accountBalance() {
      return this.$store.state.userInfo.assetsInfoMap.accountBalance > 0
        ? this.$store.state.userInfo.assetsInfoMap.accountBalance.toFixed(2)
        : "0.00";
    },
  },
  methods: {
    clickCount() {
      this.clickTimes += 1;
      if (this.clickTimes === 10 && !window.vconsole) {
        localStorage.setItem("showVConsole", true);
        location.reload();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/components/header/base.vue